import { render } from "./TheModalCancel.vue?vue&type=template&id=2ad976f8&scoped=true"
import script from "./TheModalCancel.vue?vue&type=script&lang=js"
export * from "./TheModalCancel.vue?vue&type=script&lang=js"

import "./TheModalCancel.vue?vue&type=style&index=0&id=2ad976f8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\astac\\OneDrive\\Рабочий стол\\twodolist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad976f8"]])

export default __exports__